import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { CalendarEvent } from 'src/app/shared/models/calendar-event';

@Component({
    selector: 'app-action-calendar',
    templateUrl: './action-calendar.component.html',
    styleUrls: ['./action-calendar.component.scss'],
    standalone: false
})
export class ActionCalendarComponent implements OnInit, OnChanges {

  @Input() events: CalendarEvent[] = [];

  @Output() eventClick = new EventEmitter<CalendarEvent>();

  currentDate = new Date();
  currentMonth!: number;
  currentYear!: number;

  calendar: any[] = [];

  dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  ngOnInit() {
    this.initCalendar();
  }

  ngOnChanges() {
    this.generateCalendar();
  }

  initCalendar() {
    this.currentMonth = this.currentDate.getMonth();
    this.currentYear = this.currentDate.getFullYear();
    this.generateCalendar();
  }

  generateCalendar() {

    const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
    const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();

    this.calendar = [];

    // empty cells
    for(let i=0;i<firstDay;i++){
      this.calendar.push({});
    }

    // days
    for(let date=1; date<=daysInMonth; date++){

      const fullDate = new Date(this.currentYear,this.currentMonth,date);

      const dayEvents = this.events.filter(e =>
        new Date(e.date).toDateString() === fullDate.toDateString()
      );

      this.calendar.push({
        date,
        fullDate,
        events: dayEvents,
        isToday: this.isToday(fullDate)
      });
    }
  }

  isToday(date: Date): boolean {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  }

  previousMonth(){
    this.currentMonth--;
    if(this.currentMonth < 0){
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.generateCalendar();
  }

  nextMonth(){
    this.currentMonth++;
    if(this.currentMonth > 11){
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar();
  }

  onEventClick(event: CalendarEvent){
    this.eventClick.emit(event);
  }
  getMonthName(monthIndex: number): string {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                  'July', 'August', 'September', 'October', 'November', 'December'];
  return months[monthIndex];
}

}